import * as React from "react";
import { useLocation } from "react-router-dom";
import CookiesModel from "./CookiesModel";

let defaulValues;
const PanelAppContext = React.createContext(defaulValues);

interface IPanelAppProviderProps {
    children: React.ReactNode;
}

const PanelAppProvider = ({ children }: IPanelAppProviderProps): JSX.Element => {
    const location = useLocation();

    const [cookies, setCookies] = React.useState<CookiesModel | undefined>();

    const [updateCookies, setUpdateCookies] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (updateCookies) {
            const savedCookies: CookiesModel = document.cookie.split(";").reduce((acc, cookie) => {
                const [key, value] = cookie.split("=");
                return { ...acc, [key.trim()]: value };
            }, {});

            setCookies({
                projectId: savedCookies.projectId,
                assetId: savedCookies.assetId,
                viewPanel: savedCookies.viewPanel,
                viewButton: savedCookies.viewButton,
            });

            setUpdateCookies(false);
        }
    }, [updateCookies]);

    React.useEffect(() => {
        const searchParams = new URLSearchParams(location.search);

        const urlInformation = Array.from(searchParams.keys()).reduce((acc, key) => {
            return { ...acc, [key]: searchParams.get(key) };
        }, {});

        Object.keys(urlInformation).forEach((key) => {
            document.cookie = `${key}=${urlInformation[key]}; path=/`;
        });

        if (Object.keys(urlInformation).length > 0) {
            setUpdateCookies(true);
        }
    }, [location.search]);

    return (
        <PanelAppContext.Provider value={{ cookies, setCookies }}>
            {children}
        </PanelAppContext.Provider>
    );
};

export { PanelAppProvider, PanelAppContext };
